import React, { ChangeEvent } from "react";

import RadioButton from "../../atoms/RadioButton";

import styles from "./RadioGroup.module.scss";

type Props = {
  name: string;
  options: { [key: string]: string };
  value: string | number | null | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const RadioGroup: React.FC<Props> = (props: Props) => {
  return (
    <ul className={styles.list}>
      {Object.entries(props.options).map(([key, value]) => (
        <li key={key} className={styles.listItem}>
          <RadioButton
            name={props.name}
            label={value}
            value={key}
            checked={key === `${props.value}`}
            onChange={props.onChange}
          />
        </li>
      ))}
    </ul>
  );
};

export default RadioGroup;
